import { useState, useEffect } from 'react';
import { getHealth, hasApiKey, setApiKey } from '../services/api';

export default function Header() {
  const [health, setHealth] = useState(null);
  const [showKeyInput, setShowKeyInput] = useState(false);
  const [keyValue, setKeyValue] = useState('');
  const [keySet, setKeySet] = useState(hasApiKey());

  useEffect(() => {
    const check = async () => {
      try {
        const data = await getHealth();
        setHealth(data);
      } catch {
        setHealth({ status: 'unreachable' });
      }
    };
    check();
    const interval = setInterval(check, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleSaveKey = () => {
    setApiKey(keyValue.trim());
    setKeySet(!!keyValue.trim());
    setShowKeyInput(false);
    setKeyValue('');
  };

  const dot = health?.status === 'healthy' ? 'healthy' : 'degraded';

  return (
    <header className="app-header">
      <div className="app-header-left">
        <div className="app-logo">OCR</div>
        <span className="app-title">BuddlOCR</span>
        <span className="app-subtitle">Extraction & Conversion de Documents</span>
      </div>
      <div className="header-right">
        <div className="api-key-section">
          {showKeyInput ? (
            <div className="api-key-input-group">
              <input
                type="password"
                placeholder="Clé API..."
                value={keyValue}
                onChange={(e) => setKeyValue(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSaveKey()}
                className="api-key-input"
                autoFocus
              />
              <button onClick={handleSaveKey} className="btn-sm btn-primary">OK</button>
              <button onClick={() => setShowKeyInput(false)} className="btn-sm btn-ghost">Annuler</button>
            </div>
          ) : (
            <button
              onClick={() => setShowKeyInput(true)}
              className={`btn-sm ${keySet ? 'btn-success' : 'btn-warning'}`}
              title={keySet ? 'Clé API configurée' : 'Configurer la clé API'}
            >
              {keySet ? '🔑 Clé API ✓' : '🔓 Configurer clé API'}
            </button>
          )}
        </div>
        <div className="health-status">
          <span className={`health-dot ${dot}`} />
          <span>
            {health?.status === 'healthy'
              ? 'API connectée'
              : health?.status === 'degraded'
                ? 'Services dégradés'
                : 'API déconnectée'}
          </span>
          {health?.services && (
            <span style={{ fontSize: 11, opacity: 0.6 }}>
              Redis: {health.services.redis} | OCR: {health.services.ocrEngine}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
